<mat-dialog-content class="mat-typography" style="white-space: pre-wrap;">{{ config.data.message }}</mat-dialog-content>
<br>
<br>

<div class="d-flex flex-row justify-content-end">
  <button mat-raised-button color="accent" (click)="cancel()" class="me-2" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="accept()" cdkFocusInitial>Accept</button>
</div>
